import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.406 8.016 10 13.02 14.608 8 16 9.402c-2.545 2.816-4.076 4.485-4.594 5.007a1.979 1.979 0 0 1-2.812 0L4 9.422l1.406-1.406Z" }, null, -1)
  ])))
}
export default { render: render }